import PropTypes from 'prop-types';
import {
  useRef,
  useReducer,
} from 'react';

// import { displayJson } from '../../utils';
import worldPolygon from '../../utils/geo/worldPolygon';
import {
  LeafletMap,
  LeafletPolygon,
} from '../leaflet';

import PxMapRadarActions from './PxMapRadarActions';
import PxMapRadarMarkersOverlay from './PxMapRadarMarkersOverlay';

const mapInitialState = {
  mapReady: false,
  markersContainerReady: false,
  allReady: false,
};

const mapStateReducer = (state, action) => {
  // console.log(`action=${JSON.stringify(action)}, state=${JSON.stringify(state)}`);
  switch (action.type) {
    case 'setMapReady':
      if (state.mapReady === action.ready) return state;
      return ({
        ...state,
        mapReady: action.ready,
        allReady: action.ready && state.markersContainerReady,
      });
    case 'setMarkersContainerReady':
      if (state.markersContainerReady === action.ready) return state;
      return ({
        ...state,
        markersContainerReady: action.ready,
        allReady: action.ready && state.mapReady,
      });
    default:
      throw new Error();
  }
};

function PxMapRadar(props) {
  const {
    style = {},
    markerSize = 4,
    mapConfig,
    mapCenter,
    markersPending, markersArrayRef,
    polygons = [],
    zoomBounds = null,
  } = props;
  const {
    latN = 80,
    latS = -80,
    lngW = -180,
    lngE = 180,
  } = mapConfig;

  // Persistent local variables, which don't directly trigger a React redraw:
  const mapZoom = useRef(3);

  const [mapState, mapStateDispatch] = useReducer(mapStateReducer, mapInitialState);

  const calcMapCenter = mapCenter
  || [(latN + latS) / 2, (lngW + lngE) / 2];

  // useEffect(() => {
  //   console.log(`mapConfig=${displayJson(mapConfig, 3)}`);
  // }, [mapConfig]);

  // useEffect(() => {
  //   console.log(`mapCenter=${JSON.stringify(mapCenter)} calcMapCenter=${
  //  JSON.stringify(calcMapCenter)}`);
  // }, [mapCenter, calcMapCenter]);

  return (
    <div
      style={{
        // color: '0xFF0000',
        // backgroundColor: '0x00FF00',
        opacity: '0.65',
        ...style,
      }}
      // onClick={() => { console.log('Radar click'); }}
    >
      <LeafletMap
        preferCanvas
        style={{
          height: '100%',
        }}
        center={calcMapCenter}
        zoom={mapZoom.current}
        minZoom={3}
        maxZoom={19}
        zoomControl={false}
        attributionControl={false}
        dragging={false}
        doubleClickZoom={false}
        boxZoom={false}
        trackResize={false}
        scrollWheelZoom={false}
        whenReady={() => { mapStateDispatch({ type: 'setMapReady', ready: true }); }}
      >
        <LeafletPolygon
          positions={worldPolygon}
          pathOptions={{
          // edge:
            stroke: false,
            // body:
            fillColor: '#000000',
            fillOpacity: '1',
          }}
        />
        <LeafletPolygon
          positions={polygons}
          pathOptions={{
          // edge:
            color: '#3377e0',
            opacity: 0.9,
            weight: 1,
            // body:
            fill: false,
          }}
        />

        <PxMapRadarActions
          allReady={mapState.allReady}
          mapConfig={mapConfig}
          zoomBounds={zoomBounds}
        />

        <PxMapRadarMarkersOverlay
          allReady={mapState.allReady}
          mapStateDispatch={mapStateDispatch}
          markerSize={markerSize}
          markersPending={markersPending}
          markersArrayRef={markersArrayRef}
        />

      </LeafletMap>
    </div>
  );
}

PxMapRadar.propTypes = {
  style: PropTypes.shape({}),
  markerSize: PropTypes.number,
  mapConfig: PropTypes.shape({
    latN: PropTypes.number,
    latS: PropTypes.number,
    lngW: PropTypes.number,
    lngE: PropTypes.number,
    label: PropTypes.string,
  }).isRequired,
  mapCenter: PropTypes.arrayOf(
    PropTypes.number,
  ),
  polygons: PropTypes.arrayOf(PropTypes.shape),
  markersPending: PropTypes.bool.isRequired,
  markersArrayRef: (PropTypes.shape({
    current: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string,
        lat: PropTypes.number,
        lng: PropTypes.number,
        anchor: PropTypes.shape({
          x: PropTypes.number,
          y: PropTypes.number,
        }),
        angle: PropTypes.number,
        opacity: PropTypes.number,
        color: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
      }),
    ),
  })),
  zoomBounds: PropTypes.arrayOf(PropTypes.shape),
};

export default PxMapRadar;
